/**
 * @owner @Appboy/growth-engineering
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const milestoneChecklistCacheKeys: AllRouteEndpoints[] = ["/milestone_checklist"];

/**
 * User types for milestone group configuration
 * These define the different user personas that can have different checklist experiences
 */
export const USER_MILESTONE_GROUPS = {
  developer: ["developer_getting_started", "developer_architect_with_braze"],
  marketer: ["marketer_getting_started", "marketer_scale_your_strategy"],
  admin: ["admin_getting_started", "uplevel_your_team_strategy"],
} as const;

export type UserType = keyof typeof USER_MILESTONE_GROUPS;
